import { forwardRef } from "react";
function SvgRawEyeIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="currentColor"
        strokeWidth={2}
        d="M28 16s-5.373 8-12 8-12-8-12-8 5.373-8 12-8 12 8 12 8Z"
      />
      <circle cx={16} cy={16} r={4} fill="currentColor" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawEyeIcon);
export default ForwardRef;
